<template>
  <div class="people section">
    <div class="container">
      <h1 class="title">People</h1>

      <div class="add-person container box">
        <h2 class="subtitle">Add minister</h2>
        <div class="level">
          <input type="file" @change="fileSelected(null, $event)" />
          <input v-model="person.name" type="text"
            placeholder="Minister name" class="input" />
          <input v-model="person.twitter" type="text"
            placeholder="Twitter" class="input" />
          <button v-on:click="add" class="button is-primary" :disabled="!person.photo">
            Add minister
          </button>
        </div>
      </div>

      <div>
        <div class="media" v-for="(key, person) in people" @click="openEdit(key)">
          <div class="media-left">
            <figure class="image is-128x128">
              <img v-bind:src="person.photo" />
            </figure>
          </div>
          <div class="media-content">
            <h2 class="subtitle">{{person.name}}</h2>
            {{person.twitter}}
            <div>
              <button @click="deletePerson(key, person)" class="button is-danger is-pulled-right">Delete</button>
            </div>
          </div>

          <div :class="['modal', {'is-active': (key == openModalKey)}]">
            <div class="modal-background" @click="closeEdit"></div>
            <div class="modal-card">
              <header class="modal-card-head">
                <p class="modal-card-title">Edit person</p>
                <button class="delete" @click="closeEdit"></button>
              </header>
              <section class="modal-card-body">
                <input type="file" @change="fileSelected(key, $event)" v-show="!person.photo" />
                <figure class="image is-128x128" v-show="person.photo" :title="person.photo">
                  <img v-bind:src="person.photo" />
                </figure>
                <button v-show="person.photo" class="button is-danger" @click="deletePhoto(key)">Delete photo</button>

                <input v-model="person.name" type="text"
                  placeholder="Minister name" class="input" />
                <input v-model="person.twitter" type="text"
                  placeholder="Twitter" class="input" />
              </section>
              <footer class="modal-card-foot">
                <a class="button is-success" @click="save(key)">Save</a>
                <a class="button" @click="closeEdit">Cancel</a>
              </footer>
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
import fb from 'firebase'

export default {
  data: function() {
    return {
      people: {},
      person: {},
      openModalKey: false
    }
  },
  ready: function() {
    let self = this

    fb.database().ref('people').on('value', function(snapshot) {
      self.people = snapshot.val()
    })
  },
  methods: {
    openEdit: function(key) {
      this.openModalKey = key
    },

    closeEdit: function(e) {
      e.cancelBubble = true
      this.openModalKey = false
    },

    save: function(key) {
      let ref = fb.database().ref('people/' + key)
      console.log(this.people[key])
      ref.update(this.people[key])
      this.$alert('Dunnit.')
    },

    fileSelected: function(personKey, e) {
      let self = this
      let file = e.target.files[0]
      let ref = firebase.storage().ref('people');
      let ext = (file.name).match(/\.[0-9a-z]+$/i);
      let personRef = ref.child(Date.now() + ext);
      let uploadTask = personRef.put(file);

      uploadTask.on('state_changed', null, null, function() {
        var downloadUrl = uploadTask.snapshot.downloadURL;

        if (personKey) { //this person exists already in db
          self.people[personKey].photo = downloadUrl;
        } else { // this is going to be a new person
          self.person.photo = downloadUrl;
        }

      });

    },

    add: function() {
      console.log('adding person: ', this.person)
      var personRef = fb.database().ref('people').push()
      personRef.set(this.person)
    },

    deletePerson: function(personKey, person) {
      fb.database().ref('people/' + personKey).set(null)
      if (person.photo) {
        fb.storage().refFromURL(person.photo).delete()
      }
    },

    deletePhoto: function(personKey) {
      fb.storage().refFromURL(this.people[personKey].photo).delete()
      this.people[personKey].photo = null
    }
   }
}
</script>

<style lang="less" scoped>
  .people {
    img {
      width: 100px;
    }
  }

  .media {
    cursor: pointer;
  }
</style>



/** WEBPACK FOOTER **
 ** PeopleAdmin.vue?7170fe31
 **/